export default "__VITE_ASSET__MEEuJUqp__"